import { render } from "./EmotionMarket.vue?vue&type=template&id=130ed243&scoped=true"
import script from "./EmotionMarket.vue?vue&type=script&lang=js"
export * from "./EmotionMarket.vue?vue&type=script&lang=js"

import "./EmotionMarket.vue?vue&type=style&index=0&id=130ed243&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ed243"]])

export default __exports__